import script from "./commodity.vue?vue&type=script&setup=true&lang=js"
export * from "./commodity.vue?vue&type=script&setup=true&lang=js"

import "./commodity.vue?vue&type=style&index=0&id=4c77df18&scoped=true&lang=less"

import exportComponent from "/data/opt/jenkins/workspace/prod/建博会大药房/dms-web-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c77df18"]])

export default __exports__